export default "__VITE_ASSET__H3I1MhRL__"